module.exports = __webpack_public_path__ + "img/slide2.9bf62e5c.jpg";